import { createThemeContract } from '@vanilla-extract/css';
import {
  blue,
  gray,
  green,
  lightBlue,
  lightOrange,
  lightTeal,
  lightYellow,
  purple,
  red,
  white,
  yellow,
} from '../palette';

export const smTokens = {
  surface: {
    nav: purple[900],
    base: gray[200],
    disabled: gray[200],

    brand: {
      default: purple[50],
      hover: purple[100],
      active: purple[200],
    },

    primary: {
      default: white[900],
      hover: gray[100],
      active: gray[200],
    },

    secondary: {
      default: gray[100],
      hover: gray[200],
      active: gray[300],
    },

    tertiary: {
      default: gray[200],
      hover: gray[300],
      active: gray[400],
    },

    alert: {
      critical: {
        default: red[50],
        hover: red[100],
        active: red[200],
      },
      warning: {
        default: yellow[50],
        hover: yellow[100],
        active: yellow[200],
      },
      success: {
        default: green[50],
        hover: green[100],
        active: green[200],
      },
      info: {
        default: blue[50],
        hover: blue[100],
        active: blue[200],
      },
    },

    aux: {
      lightBlue: {
        default: lightBlue[50],
        hover: lightBlue[100],
        active: lightBlue[200],
      },
      lightTeal: {
        default: lightTeal[50],
        hover: lightTeal[100],
        active: lightTeal[200],
      },
      lightOrange: {
        default: lightOrange[50],
        hover: lightOrange[100],
        active: lightOrange[200],
      },
      lightYellow: {
        default: lightYellow[50],
        hover: lightYellow[100],
        active: lightYellow[200],
      },
    },
  },

  bg: {
    disabled: gray[200],

    brand: {
      default: purple[900],
      hover: purple[800],
      active: purple[700],
    },

    secondary: {
      default: gray[300],
      hover: gray[400],
      active: gray[500],
    },

    tertiary: {
      default: white[50],
      hover: gray[100],
      active: gray[200],
    },

    inverse: {
      default: white[900],
      hover: white[800],
      active: white[700],
    },

    nav: {
      default: purple[900],
      hover: white[50],
      active: white[100],
      disabled: purple[900],
    },

    alert: {
      critical: {
        default: red[900],
        hover: red[800],
        active: red[700],
      },

      success: {
        default: green[900],
        hover: green[800],
        active: green[700],
      },
    },
  },

  text: {
    brand: purple[900],
    primary: gray[900],
    secondary: gray[700],
    tertiary: gray[600],
    inverse: white[900],
    link: purple[500],
    disabled: gray[500],

    nav: {
      default: purple[100],
      disabled: white[400],
    },

    alert: {
      critical: red[900],
      warning: yellow[900],
      success: green[900],
      info: blue[900],
    },
  },

  icon: {
    brand: purple[900],
    primary: gray[900],
    secondary: gray[700],
    inverse: white[900],
    link: purple[500],
    disabled: gray[500],

    alert: {
      critical: red[900],
      warning: yellow[900],
      success: green[900],
      info: blue[900],
    },

    aux: {
      lightTeal: lightTeal[900],
      lightOrange: lightOrange[900],
      lightBlue: lightBlue[900],
      lightYellow: lightYellow[900],
    },
  },

  border: {
    brand: purple[900],
    primary: gray[700],
    secondary: gray[500],
    tertiary: gray[400],
    quaternary: gray[300],

    inverse: white[900],
    disabled: gray[200],

    alert: {
      critical: red[900],
      success: green[900],
    },
  },
};

export const smVars = createThemeContract(smTokens);
